var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    { positive: _vm.percentage > 0, neutral: _vm.percentage == 0, simple: _vm.simple },
    'price-move-container' ]},[_vm._v(" "+_vm._s(_vm.percentage > 0 ? "+ " : _vm.percentage !== 0 ? "- " : "")+_vm._s(_vm.percentageNoSign)+_vm._s(_vm.simple ? " " + _vm.units : _vm.units)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }